<template>
  <div
    class="kb-categories__item"
  >
    <h4 :id="`${subCategory.id}`">
      {{ subCategory.name }}
    </h4>
    <h6>
      <ul :class="`kb-subcategory__articles ${isExpanded && 'expanded'}`">
        <li
          v-for="(post, index) in subCategory.posts"
          :key="post.id"
          :class="{ 'expanded-only': index > 3 }"
        >
          <router-link :to="`/faq/${post.id}?category=${categoryId}`">
            {{ post.title }}
          </router-link>
        </li>
        <a
          v-show="subCategory.posts.length > 4"
          role="button"
          class="kb-subcategory__expand-articles-toggle kb__text-link"
          style="cursor: pointer;"
          @click="isExpanded = !isExpanded"
        >
          {{ isExpanded ? '表示を減らす' : 'さらに表示' }}
        </a>
      </ul>
    </h6>
  </div>
</template>

<script>
export default {
    name: 'CategoryItem',
    props: {
        subCategory: {
            type: Object,
            required: true
        },
        categoryId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isExpanded: false
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
